import { ShareRegisterActionTypes } from "models/actionTypes/shareRegisterActionTypes";
import { ReduxConstants } from "utils/constants";

export const shareRegisterAccepted = (id: number): ShareRegisterActionTypes => {
  return {
    type: ReduxConstants.ShareRegisterActions.SHARE_REGISTER_ACCEPTED,
    payload: id,
  };
};

export const shareRegisterSnoozed = (id: number): ShareRegisterActionTypes => {
  return {
    type: ReduxConstants.ShareRegisterActions.SHARE_REGISTER_SNOOZED,
    payload: id,
  };
};

export const shareRegisterRejected = (id: number): ShareRegisterActionTypes => {
  return {
    type: ReduxConstants.ShareRegisterActions.SHARE_REGISTER_REJECTED,
    payload: id,
  };
};
